import { IRSSScheduleInfo } from './../../email-preview/src/types'
import timezone from 'dayjs/esm/plugin/timezone'
import dayjs from 'dayjs'
import i18n from '../locales'
import { renderIcon } from '@gohighlevel/ghl-ui'
import {
  Send03Icon,
  CalendarIcon,
  Dataflow02Icon,
  Rss01Icon,
} from '@gohighlevel/ghl-icons/24/outline'
// @ts-ignore
dayjs.extend(timezone)

export const PAGE_LIMIT = 10
export const WARNING_MESSAGES: { [key: string]: string } = {
  MAKE_SURE_VALID_EMAIL: 'make_sure_valid_email',
}

export const COMMON_LABELS: { [key: string]: string } = {
  BACK: 'back',
  BACK_TO_BUILDER: 'back_to_builder',
}

// TOTAL_ATTEMPTED: 'total',
export const CAMPAIGN_STATS_TAB = {
  DELIVERED: 'delivered',
  OPENED: 'opened',
  CLICKED: 'clicked',
  ORDERS: 'orders',
  REPLIED: 'replied',
  BOUNCED: 'permanent_fail',
  SOFT_BOUNCED: 'temporary_fail',
  COMPLAINED: 'complained',
  UNSUBSCRIBED: 'unsubscribed',
  ERROR: 'error',
}

const getTimeWithIntervals = (
  interval: number = 15,
  startTime: number = 0
): Array<string> => {
  var times = [] // time array
  var ap = ['AM', 'PM'] // AM-PM

  //loop to increment the time and push results in array
  for (var i = 0; startTime < 24 * 60; i++) {
    var hh = Math.floor(startTime / 60) // getting hours of day in 0-24 format
    var mm = startTime % 60 // getting minutes of the hour in 0-55 format
    times[i] = `${('0' + (hh % 12)).slice(-2)}:${('0' + mm).slice(-2)} ${
      ap[Math.floor(hh / 12)]
    }`
    // pushing data in array in [00:00 - 12:00 AM/PM format]
    startTime = startTime + interval
  }
  return times
}

export const scheduleTimeSlots = getTimeWithIntervals()

export const getRecurringPeriodMenuOptions = () => [
  { label: i18n.global.t('campaignSchedule.everyDay'), value: 'every_day' },
  { label: i18n.global.t('campaignSchedule.everyWeek'), value: 'every_week' },
  { label: i18n.global.t('campaignSchedule.everyMonth'), value: 'every_month' },
]

export const CAMPAIGN_TYPE_KEYS = {
  RSS: 'rssEmailSchedule',
  DRIP_SCHEDULE: 'dripSchedule',
  SCHEDULE_LATER: 'schedule',
  SEND_NOW: 'send-now',
  AB_TEST: 'abtest',
}

export function getScheduleOptions(isABTestCampaign = false) {
  return {
    [CAMPAIGN_TYPE_KEYS.SEND_NOW]: {
      key: CAMPAIGN_TYPE_KEYS.SEND_NOW,
      icon: renderIcon(Send03Icon),
      title: i18n.global.t('campaignSchedule.sendNow'),
      description: i18n.global.t('campaignSchedule.sendNowHelper'),
      class: 'w-8 h-5',
      isDisabled: false,
    },
    [CAMPAIGN_TYPE_KEYS.SCHEDULE_LATER]: {
      key: CAMPAIGN_TYPE_KEYS.SCHEDULE_LATER,
      icon: renderIcon(CalendarIcon),
      title: i18n.global.t('campaignSchedule.schedule'),
      description: i18n.global.t('campaignSchedule.scheduleHelper'),
      class: 'w-7 h-6',
      isDisabled: false,
    },
    [CAMPAIGN_TYPE_KEYS.DRIP_SCHEDULE]: {
      key: CAMPAIGN_TYPE_KEYS.DRIP_SCHEDULE,
      icon: renderIcon(Dataflow02Icon),
      title: i18n.global.t('campaignSchedule.batchSchedule'),
      description: i18n.global.t('campaignSchedule.batchScheduleHelper'),
      class: 'w-12 h-6',
      isDisabled: isABTestCampaign,
    },
    [CAMPAIGN_TYPE_KEYS.RSS]: {
      key: CAMPAIGN_TYPE_KEYS.RSS,
      icon: renderIcon(Rss01Icon),
      title: i18n.global.t('campaignSchedule.rssSchedule'),
      description: i18n.global.t('campaignSchedule.rssScheduleHelper'),
      class: 'w-10 h-6',
      isDisabled: isABTestCampaign,
    },
  }
}

export const AB_CAMPAIGN_TYPE_KEYS = {
  EMAIL_SUBJECT: 'emailSubject',
  EMAIL_CONTENT: 'emailContent',
}

export const getABCampaignType = (): { [key: string]: string } => {
  return {
    emailSubject: i18n.global.t('common.emailSubject'),
    emailContent: i18n.global.t('common.emailContent'),
  }
}
export const getABCampaignTypeName = () => {
  const AB_CAMPAIGN_TYPE_MAP = getABCampaignType()
  return {
    [AB_CAMPAIGN_TYPE_KEYS.EMAIL_SUBJECT]: {
      icon: 'custom-icon:send',
      title: AB_CAMPAIGN_TYPE_MAP.emailSubject,
      description: i18n.global.t('common.sendNowHelper'),
      class: 'w-6 h-4',
    },
    [AB_CAMPAIGN_TYPE_KEYS.EMAIL_CONTENT]: {
      icon: 'heroicons-outline:calendar',
      title: AB_CAMPAIGN_TYPE_MAP.emailContent,
      description: 'Pick a date and time to schedule',
      class: 'w-5 h-4',
    },
  }
}
export const AB_CAMPAIGN_WINNING_CRITERIA_KEYS = {
  OPEN_RATE: 'openRate',
  CLICK_RATE: 'clickRate',
}

export const getABWinningCriteria = () => {
  return {
    openRate: i18n.global.t('ABTesting.uniqueOpenRate'),
    clickRate: i18n.global.t('ABTesting.uniqueClickRate'),
  }
}
export const getABWinningCriteriaName = () => {
  const AB_CAMPAIGN_WINNING_CRITERIA_MAP = getABWinningCriteria()
  return {
    [AB_CAMPAIGN_WINNING_CRITERIA_KEYS.OPEN_RATE]: {
      icon: 'custom-icon:send',
      title: AB_CAMPAIGN_WINNING_CRITERIA_MAP.openRate,
      description: i18n.global.t('ABTesting.uniqueOpenRateHelper'),
      class: 'w-6 h-4',
    },
    [AB_CAMPAIGN_WINNING_CRITERIA_KEYS.CLICK_RATE]: {
      icon: 'heroicons-outline:calendar',
      title: AB_CAMPAIGN_WINNING_CRITERIA_MAP.clickRate,
      description: i18n.global.t('ABTesting.uniqueClickRateHelper'),
      class: 'w-5 h-4',
    },
  }
}
export const CAMPAIGN_TYPE_COLOR_MAP = {
  rss: 'bg-teritary-100 text-teritary-800,',
  send_now: 'bg-blue-100 text-blue-800',
  drip_schedule: 'bg-green-100 text-green-800',
  schedule_later: 'bg-green-100 text-green-800',
  draft: 'bg-gray-100 text-gray-800',
  folder: 'bg-apple-100 text-apple-800',
}

export const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const WEEK_DAYS_LABELS = [
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
  { label: 'Sunday', value: '0' },
]

function getNumberWithOrdinal(n: number) {
  var s = ['th', 'st', 'nd', 'rd'],
    v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}
export const getCurrentMonthDays = function () {
  const dayCount = dayjs('2019-01-25').daysInMonth()
  let daysLabels = []
  for (let i = 1; i <= dayCount; i++) {
    daysLabels.push({ label: getNumberWithOrdinal(i), value: String(i) })
  }

  return daysLabels
}

function getSpecifcDayOfMonth(date: dayjs.Dayjs, monthDay) {
  if (date.date() != monthDay) {
    date = date.date(parseInt(monthDay))
  }
  if (date.date() != monthDay) {
    date = date.month(date.month() + 1)
    date = date.date(parseInt(monthDay))
  }
  return date
}

export const getNextTime = function (
  rssSchedule: IRSSScheduleInfo,
  timeZone: string
) {
  const RECURRING_PERIODS = getRecurringPeriodMenuOptions()
  let nextTime = null
  try {
    const { repeatAfter, repeatAfterTime, startAtDay, startAtMonthDay } =
      rssSchedule

    nextTime = dayjs(
      dayjs().tz(timeZone).format('YYYY-MM-DD') + ` ${repeatAfterTime}`,
      'YYYY-MM-DD HH:mm A'
    ).tz(timeZone, true)

    if (RECURRING_PERIODS[1].value === repeatAfter && startAtDay) {
      nextTime = dayjs(nextTime).day(parseInt(startAtDay))
    }
    if (RECURRING_PERIODS[2].value === repeatAfter && startAtMonthDay) {
      nextTime = dayjs(nextTime).date(parseInt(startAtMonthDay))
      nextTime = getSpecifcDayOfMonth(nextTime, startAtMonthDay)
    }
    const currentTime = dayjs().tz(timeZone)

    if (currentTime.isBefore(nextTime)) {
      nextTime = nextTime
    } else {
      switch (repeatAfter) {
        case RECURRING_PERIODS[0].value: {
          nextTime = nextTime.add(1, 'days')
          break
        }
        case RECURRING_PERIODS[1].value: {
          nextTime = nextTime.add(7, 'days')
          break
        }
        case RECURRING_PERIODS[2].value: {
          nextTime = nextTime.add(30, 'days')
          nextTime = getSpecifcDayOfMonth(nextTime, startAtMonthDay)
          break
        }
        //for safer side adding 2 days : default case
        default: {
          nextTime.add(2, 'days')
        }
      }
    }
  } catch (err) {
    console.warn('fail to get next execution', err)
    nextTime = null
  }

  return nextTime
}
export interface SelectOptions {
  label: string
  value: string
}

const ALL_KEYS = {
  ...WARNING_MESSAGES,
  ...COMMON_LABELS,
  ...CAMPAIGN_STATS_TAB,
}

export default ALL_KEYS
export const EMAIL_PREVIEW_ROUTES_NAMES = {
  EMAIL_TEMPLATE_VERSIONS: 'email_template_version',
  EMAIL_PREVIEW_TEMPLATE: 'email_preview_template',
  EMAIL_TEMPLATE_RENDER: 'email_template_render',
  EMAIL_TEMPLATE_BUILDER: 'builder',
}

export const EditorTypes = {
  HTML: 'html',
  BUILDER: 'builder',
}

export const EmailTemplateProviders = [
  { label: 'Mailchimp', value: 'mailchimp' },
  { label: 'Active Campaign', value: 'active_campaign' },
  { label: 'Kajabi', value: 'kajabi' },
]

export const ABTestDurationOptions = [
  {
    label: '30 min',
    value: 1800,
  },
  {
    label: '1 hour',
    value: 3600,
  },
  {
    label: '2 hour',
    value: 7200,
  },
  {
    label: '4 hour',
    value: 14400,
  },
  {
    label: '8 hour',
    value: 28800,
  },
  {
    label: '12 hour',
    value: 43200,
  },
  {
    label: '18 hour',
    value: 64800,
  },
  {
    label: '24 hour',
    value: 86400,
  },
]

export const supportedAttachmentTypes = [
  { mimeType: 'application/excel', extensions: ['.xls'] },
  { mimeType: 'application/vnd.ms-excel', extensions: ['.xls'] },
  { mimeType: 'application/x-excel', extensions: ['.xls'] },
  { mimeType: 'application/x-msexcel', extensions: ['.xls'] },
  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extensions: ['.xlsx'],
  },
  {
    mimeType: 'application/vnd.oasis.opendocument.spreadsheet',
    extensions: ['.ods'],
  },
  { mimeType: 'application/vnd.oasis.opendocument.text', extensions: ['.odt'] },
  { mimeType: 'application/doc', extensions: ['.doc'] },
  { mimeType: 'application/ms-doc', extensions: ['.doc'] },
  { mimeType: 'application/msword', extensions: ['.doc'] },
  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extensions: ['.docx'],
  },
  {
    mimeType: 'application/vnd.ms-word.document.macroenabled.12',
    extensions: ['.docm'],
  },
  { mimeType: 'text/csv', extensions: ['.csv'] },
  { mimeType: 'application/pdf', extensions: ['.pdf'] },
  { mimeType: 'text/plain', extensions: ['.txt'] },
  { mimeType: 'text/css', extensions: ['.css'] },
  { mimeType: 'image/gif', extensions: ['.gif'] },
  { mimeType: 'image/jpeg', extensions: ['.jpg', '.jpeg'] },
  { mimeType: 'image/pjpeg', extensions: ['.jpg', '.jpeg'] },
  { mimeType: 'image/png', extensions: ['.png'] },
  { mimeType: 'image/tiff', extensions: ['.tiff'] },
  { mimeType: 'image/x-tiff', extensions: ['.tiff'] },
  { mimeType: 'image/x-icon', extensions: ['.ico'] },
  { mimeType: 'image/svg+xml', extensions: ['.svg'] },
  { mimeType: 'image/bmp', extensions: ['.bmp'] },
  { mimeType: 'image/cgm', extensions: ['.cgm'] },
  { mimeType: 'image/webp', extensions: ['.webp'] },
  { mimeType: 'application/mspowerpoint', extensions: ['.ppt'] },
  { mimeType: 'application/powerpoint', extensions: ['.ppt'] },
  { mimeType: 'application/vnd.ms-powerpoint', extensions: ['.ppt'] },
  { mimeType: 'application/x-mspowerpoint', extensions: ['.ppt'] },
  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    extensions: ['.pptx'],
  },
  {
    mimeType: 'application/vnd.oasis.opendocument.presentation',
    extensions: ['.odp'],
  },
  { mimeType: 'application/rtf', extensions: ['.rtf'] },
  { mimeType: 'audio/mpeg', extensions: ['.mp3'] },
  { mimeType: 'audio/mpeg3', extensions: ['.mp3'] },
  { mimeType: 'audio/x-mpeg-3', extensions: ['.mp3'] },
  { mimeType: 'video/mpeg', extensions: ['.mpeg'] },
  { mimeType: 'video/x-mpeg', extensions: ['.mpeg'] },
  { mimeType: 'audio/wav', extensions: ['.wav'] },
  { mimeType: 'audio/x-wav', extensions: ['.wav'] },
  { mimeType: 'audio/ogg', extensions: ['.ogg'] },
  { mimeType: 'application/akn+xml', extensions: ['.akn'] },
  { mimeType: 'application/rif+xml', extensions: ['.rif'] },
  { mimeType: 'application/tar', extensions: ['.tar'] },
  { mimeType: 'application/x-tar', extensions: ['.tar'] },
  { mimeType: 'application/zip', extensions: ['.zip'] },
  { mimeType: 'application/andrew-inset', extensions: ['.ez'] },
  { mimeType: 'text/calendar', extensions: ['.ics'] },
  { mimeType: 'application/x-mobipocket-ebook', extensions: ['.mobi'] },
  { mimeType: 'application/vnd.contact.cmsg', extensions: ['.cmsg'] },
  { mimeType: 'application/x-mspublisher', extensions: ['.pub'] },
  { mimeType: 'application/postscript', extensions: ['.ps'] },
  { mimeType: 'video/x-m4a', extensions: ['.m4a'] },
  { mimeType: 'video/x-m4v', extensions: ['.m4v'] },
  { mimeType: 'audio/x-ms-wma', extensions: ['.wma'] },
  { mimeType: 'audio/flac', extensions: ['.flac'] },
  { mimeType: 'audio/aiff', extensions: ['.aif'] },
  { mimeType: 'audio/x-aiff', extensions: ['.aif'] },
  { mimeType: 'video/x-sgi-movie', extensions: ['.movie'] },
  { mimeType: 'video/mp4', extensions: ['.mp4'] },
  { mimeType: 'video/x-msvideo', extensions: ['.avi'] },
  { mimeType: 'video/x-matroska', extensions: ['.mkv'] },
  { mimeType: 'video/x-ms-wmv', extensions: ['.wmv'] },
  { mimeType: 'application/vnd.ms-outlook', extensions: ['.msg'] },
  {
    mimeType: 'application/vnd.ms-excel.sheet.macroEnabled.12',
    extensions: ['.xlsm'],
  },
  {
    mimeType: 'application/vnd.ms-excel.template.macroEnabled.12',
    extensions: ['.xltm'],
  },
  {
    mimeType: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    extensions: ['.pptm'],
  },
  {
    mimeType: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
    extensions: ['.potm'],
  },
  {
    mimeType: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    extensions: ['.ppsm'],
  },
  {
    mimeType: 'application/vnd.ms-word.document.macroEnabled.12',
    extensions: ['.docm'],
  },
  {
    mimeType: 'application/vnd.ms-word.template.macroEnabled.12',
    extensions: ['.dotm'],
  },
  { mimeType: 'application/vnd.apple.keynote', extensions: ['.key'] },
  { mimeType: 'application/vnd.apple.numbers', extensions: ['.numbers'] },
  { mimeType: 'application/vnd.apple.pages', extensions: ['.pages'] },
  { mimeType: 'application/x-iwork-keynote-sffkey', extensions: ['.key'] },
  { mimeType: 'application/x-iwork-pages-sffpages', extensions: ['.pages'] },
  {
    mimeType: 'application/x-iwork-numbers-sffnumbers',
    extensions: ['.numbers'],
  },
]

//  10MB
export const maxUploadSize = 10485760

export const emitEvents = {
  OK_CLICK: 'ok-click',
  CLOSE_MODAL: 'close-modal',
  SHARE: 'share',
  SHOW_STATS: 'showStats',
  ARCHIVE: 'archive',
  DELETE: 'delete',
  RENAME: 'rename',
  MOVE_TO_FOLDER: 'moveToFolder',
  REFRESH_CAMPAIGN: 'refreshCampaign',
  EDIT: 'edit',
  RESCHEDULE_CAMPAIGN: 'rescheduleCampaign',
  PAUSE: 'pause',
  CLONE: 'clone',
  CREATE_CAMPAIGN: 'createCampaign',
  REFRESH_LIST: 'refresh-list',
  CREATE_FOLDER: 'create-folder',
  UNOPENED_RESEND: 'unopenedResend',
}

export const contactInfoKeys = [
  'contact_name',
  'first_name',
  'last_name',
  'email',
  'phone',
  'company_name',
  'address_1',
  'city',
  'state',
  'postal_code',
  'date_of_birth',
  'source',
  'website',
]

export const googleFontCompatibility = [
  {
    client: i18n.global.t('emailBuilder.gmail'),
    support: '❌',
  },
  {
    client: i18n.global.t('emailBuilder.appleMail'),
    support: '✅',
  },
  {
    client: i18n.global.t('emailBuilder.yahoo'),
    support: '❌',
  },
  {
    client: i18n.global.t('emailBuilder.outlook'),
    support: 'Only in iOS & macOS',
  },
]

export const sliderCompatibility = [
  {
    client: i18n.global.t('emailBuilder.gmail'),
    thumbnail: '✅',
    arrows: '❌',
  },
  {
    client: i18n.global.t('emailBuilder.appleMail'),
    thumbnail: '✅',
    arrows: '✅',
  },
  {
    client: i18n.global.t('emailBuilder.yahoo'),
    thumbnail: '✅',
    arrows: '❌',
  },
  {
    client: i18n.global.t('emailBuilder.outlook'),
    thumbnail: '❌',
    arrows: '❌',
  },
]

export const supportTableColumns = [
  { title: i18n.global.t('emailBuilder.mailClient'), key: 'client' },
  {
    title: i18n.global.t('emailBuilder.thumbnailSupport'),
    key: 'thumbnail',
    show: false,
  },
  { title: i18n.global.t('emailBuilder.arrowsSupport'), key: 'arrows' },
  { title: i18n.global.t('emailBuilder.googleFontSupport'), key: 'support' },
  { title: i18n.global.t('emailBuilder.accordionSupport'), key: 'arrows' },
]

export const fontFamilyOptions = [
  { label: 'Andale Mono', value: 'andale mono, monospace' },
  { label: 'Arial', value: 'arial, helvetica, sans-serif' },
  { label: 'Arial Black', value: 'arial black, sans-serif' },

  {
    label: 'Book Antiqua',
    value: 'book antiqua, palatino, serif',
  },
  {
    label: 'Comic Sans MS',
    value: 'comic sans ms, sans-serif',
  },
  {
    label: 'Courier New',
    value: 'courier new, courier, monospace',
  },
  {
    label: 'Georgia',
    value: 'georgia, palatino, serif',
  },
  { label: 'Helvetica', value: 'helvetica, arial, sans-serif' },
  {
    label: 'Impact',
    value: 'impact, sans-serif',
  },
  {
    label: 'Symbol',
    value: 'symbol',
  },
  {
    label: 'Tahoma',
    value: 'tahoma, arial, helvetica, sans-serif',
  },
  {
    label: 'Terminal',
    value: 'terminal, monaco, monospace',
  },
  {
    label: 'Times New Roman',
    value: 'times new roman, times, serif',
  },
  { label: 'Trebuchet', value: 'trebuchet ms, geneva, sans-serif' },
  { label: 'Verdana', value: 'verdana, geneva, sans-serif' },
  { label: 'Webdings', value: 'webdings' },
  { label: 'Wingdings', value: 'wingdings, zapf dingbats' },
]

export const settingsMenuOptions = [
  {
    label: i18n.global.t('emailCampaign.attribution'),
    key: 'attribution',
  },
  {
    label: i18n.global.t('emailCampaign.senderPreferences'),
    key: 'sender-preferences',
  },
  {
    label: i18n.global.t('emailCampaign.fonts'),
    key: 'fonts',
  },
]
